import Sidebar from "./screens/Sidebar";
import Chat from "./screens/chat";
import { useState, useEffect } from "react";

import { useMsal, useIsAuthenticated } from "@azure/msal-react";
import { loginRequest } from "./screens/authConfig";

export default function App() {
    const [messages, setMessages] = useState([]);
    const [conversationId, setConversationId] = useState("");
    const [conversationKey, setConversationKey] = useState(0);

    const { instance, inProgress } = useMsal();
    const isAuthenticated = useIsAuthenticated();

    useEffect(() => {
        if (!isAuthenticated && inProgress === "none") {
            instance.loginRedirect(loginRequest);
        }
    }, [isAuthenticated, inProgress, instance]);

    // 🔥 evita render enquanto está logando
    if (inProgress !== "none") {
        return <div>Carregando...</div>;
    }

    if (!isAuthenticated) {
        return <div>Redirecionando...</div>;
    }

    const handleNewConversation = () => {
        setMessages([]);
        setConversationId("");
        setConversationKey((current) => current + 1);
    };

    return (
        <div className="app">
            <Sidebar
                onNewConversation={handleNewConversation}
            />

            <Chat
                messages={messages}
                setMessages={setMessages}
                conversationId={conversationId}
                setConversationId={setConversationId}
                conversationKey={conversationKey}
                onNewConversation={handleNewConversation}
            />
        </div>
    );
}
